var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.isEdit ? '编辑邮件模板' : '创建邮件模板',
      "visible": _vm.showDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('el-form', {
    key: _vm.preventKey,
    ref: "ruleForm",
    staticClass: "form-beauty",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": _vm.labelWidth
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "模板名称:",
      "prop": "name",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "placeholder": "请输入模板名称"
    },
    model: {
      value: (_vm.ruleForm.name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮件标题:",
      "prop": "title",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 100,
      "placeholder": "请输入邮件标题"
    },
    model: {
      value: (_vm.ruleForm.title),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "title", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "招聘阶段:",
      "prop": "phase",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.getMailHolder(true)
      }
    },
    model: {
      value: (_vm.ruleForm.phase),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "phase", $$v)
      },
      expression: "ruleForm.phase"
    }
  }, _vm._l((_vm.selectMap.WB_PHASE), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item.text,
        "value": String(item.value)
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户类型:",
      "prop": "userAttributes",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.getMailHolder(true)
      }
    },
    model: {
      value: (_vm.ruleForm.userAttributes),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "userAttributes", $$v)
      },
      expression: "ruleForm.userAttributes"
    }
  }, _vm._l((_vm.selectMap.WB_USER_ATTRIBUTES), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否可用:",
      "prop": "visible",
      "required": ""
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.ruleForm.visible),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "visible", $$v)
      },
      expression: "ruleForm.visible"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("不可用")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("可用")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否私有:",
      "prop": "isPrivate",
      "required": ""
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.ruleForm.isPrivate),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "isPrivate", $$v)
      },
      expression: "ruleForm.isPrivate"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("是")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮件内容:",
      "prop": "content"
    }
  }, [(_vm.mailHolders.length) ? _c('div', {
    staticClass: "el-tag-operation"
  }, _vm._l((_vm.mailHolders), function(item, index) {
    return _c('el-tag', {
      key: index,
      staticClass: "mr-5",
      nativeOn: {
        "click": function($event) {
          return _vm.$refs.editor.addAfterCursor(item.value)
        }
      }
    }, [_vm._v(_vm._s(item.text) + "\n                ")])
  }), 1) : _vm._e(), _vm._v(" "), _c('vueditor', {
    ref: "editor",
    model: {
      value: (_vm.ruleForm.content),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "content", $$v)
      },
      expression: "ruleForm.content"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveDate('ruleForm')
      }
    }
  }, [_vm._v("确定")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c7dbf4c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/message/editEmailTpl.vue
// module id = null
// module chunks = 